import { takeLatest, debounce, throttle, takeLeading } from 'redux-saga/effects';
import {
  REQUEST_LOGIN_CREDENTIALS,
  AUTHENTICATION,
  CURRENT_USER,
  METADATA,
  COMPANY_ONBOARDING,
  COMPANY,
  COMMENTS,
  LIKES,
  HITFACTOR_COLLECTIONS,
  STUDENT,
  HITSEARCH,
  HITMANAGER,
  CHAT,
  SEARCHGENERAL,
  NOTIFICATIONS,
  APP_TOUR,
  BUDDIES,
  TRAITS,
  HITCLUB,
  PAYMENTS
} from 'actions/Base';

import { onCreateRequest as onRequestLoginCredentials } from './requestLoginCredentials';
import { onCreateRequest as onLogin } from './authentication';
import { 
  onGetRequest as onGetCurrentUser,
  onSetLanguageRequest,
  onSetProfilePictureRequest
} from './currentUser';
import { 
  onGetRequest as onGetMetadata, 
  onGetHobbiesRequest
} from './metadata';
import { 
  onCreateCompanyUserRequest as onCreateCompanyUser, 
  onCreateCompanyRequest as onCreateCompany 
} from './companyOnboarding'
import { 
  onGetDetailCompanyRequest, 
  onGetAllCompanyRequest,
  onGetCompanyFollowersRequest,
  onGetFeedRequest,
  onCreateCompanyPostRequest,
  onCreateUserRequest,
  onUpdateCompanyRequest,
  onUpdateCompanyUserRequest,
  onUpdateCompanyCoverImageRequest,
  onDeleteHitPostRequest,
  onConnectCompanyInstagramRequest,
  onGetCompanyHitEventsRequest,
  onDeleteInstagramRequest as onDeleteCompanyInstagramRequest,
} from './company';
import {
  onGetCommentsRequest,
  onCreateCommentRequest,
  onDeleteCommentRequest,
} from './comments';
import {
  onCreateLikeRequest,
  onDeleteLikeRequest,
} from './like';
import {
  onCreateCollectionRequest,
  onCreateCollectionImageRequest,
  onDeleteCollectionRequest,
  onDeleteImageRequest,
  onUpdateCollectionRequest,
  onUpdateCollectionImageRequest,
  onMoveImageImageRequest,
  onMoveCollectionRequest
} from './hitFactorCollections'
import {
  onGetStudentRequest
} from './student'
import { onGetRequest as onGetSearchResultRequest } from './hitSearch'
import { 
  onGetStudentInfoRequest,
  onGetReqProfileRequest, 
  onGetReqProfilesRequest, 
  onCreateReqProfileRequest, 
  onGetStudentsInReqProfileRequest,
  onGetStudentsInReqProfilesRequest,
  onGetHitActionsRequest,
  onGetStudentInfoLogRequest,
  onGetNonUpdatedStudentsInReqProfilesRequest,
  onAddStudentsToReqProfileRequest,
  onAddHitActionRequest,
  onUpdateReqProfileRequest,
  onUpdateHitActionRequest,
  onUpdateStudentInReqProfileRequest,
  onDeleteStudentsFromReqProfileRequest,
  onSearchStudentsInReqProfilesRequest,
  onSearchStudentsInReqProfileRequest,
  onDeleteReqProfileRequest,
  onDeleteHitActionRequest
} from './hitManager'

import {
  onGetCurrentChatGroupsRequest,
  onGetChatMessagesRequest,
  onCreateChatGroupRequest,
  onCreateChatMessageRequest,
  onPollRequest,
  onAddChatGroupParticipantsRequest,
  onDeleteChatGroupParticipantsRequest,
  onUserTypingRequest,
  onDispatchUserIsTypingRequest,
  onCreateChatMessageWithImageRequest,
  onCreateMultipleChatGroupByReqIdRequest,
  onCreateMultipleChatGroupByStudentIdRequest,
  onCreateMultipleChatGroupByHitClubIdRequest,
  onSearchChatGroupRequest
} from './chat';

import {
  onStudentSearchRequest,
  onUserSearchRequest,
  onHitClubSearchRequest,
  onCompanySearchRequest,
  onProductBaseSearchRequest,
  onProductOfferSearchRequest,
  onSearchHitMemberToChatWithRequest
} from './searchGeneral'

import {
  onRegisterDeviceRequest,
  onGetNotificationsRequest,
  onSetNotificationClickedRequest,
  onNotificationPollRequest,
  onSendPushNotificationRequest,
  onSendPushNotificationToHitClubRequest,
  onSendPushNotificationToHitClubExpiredRequest
} from './notifications'

import {
  onSaveStatusRequest
} from './appTour'

import {
  onGetApprovedBuddiesRequest
} from './buddies'

import {
  onGetCharacteristicGiversRequest
} from './traits'

import {
  onGetHitClubsMenuRequest,
  onGetHitClubRequest,
  onGetHitClubsRequest,
  onGetHitClubMembersRequest,
  onGetHitClubMembersRequestsRequest,
  onGetHitClubHitEventRequest,
  onGetHitClubHitEventsRequest,
  onCreateHitClubRequest,
  onEditHitClubRequest,
  onApproveMemberRequest,
  onCreateHitEventRequest,
  onEditHitEventRequest,
  onCreateHitClubOwnerRequest,
  onCreateHitClubOwnerOtherRequest,
  onImportMembersRequest,
  onSendRemindersToMembersRequest,
  onSendRemindersToAllRequest,
  onRemoveHitClubOwnerRequest,
  onEditHitMemberRequest,
  onRemoveHitMemberRequest,
  onCreateTicketRequest,
  onEditTicketRequest,
  onGetTicketQuestionsRequest,
  onCreateTicketQuestionsRequest,
  onDeleteTicketQuestionsRequest,
  onEditTicketQuestionsRequest,
  onRemoveTicketRequest,
  onCreateMembershipOfferRequest,
  onEditMembershipOfferRequest,
  onDeleteMembershipOfferRequest,
  onRemoveHitEventRequest,
  onConnectInstagramRequest,
  onGetHitClubMemberLogRequest,
  onUploadAdmissionFileRequest,
  onUploadRegistrationFileRequest,
  onAddMemberRequest,
  onGetHitClubFeedRequest,
  onGetHitEventFeedRequest,
  onDeleteStudentPostRequest,
  onCreateStudentPostRequest,
  onEditStudentPostRequest,
  onDeleteInstagramRequest as onDeleteHitClubInstagramRequest,
  onUpdateMemberStatusRequest,
  onGetParametersEditHitEventRequest,
  onGetParametersCreateTicketRequest,
  onGetParametersEditTicketRequest,
  onDeleteInstagramPostRequest,
  onCreateSalesReportRequest,
  onCreatePayoutReportRequest,
  onGetHitClubProductBaseRequest,
  onGetHitClubProductBasesRequest,
  onCreateHitClubProductBaseRequest,
  onGetProductGroupsRequest,
  onCreateHitEventProductGroupRequest,
  onGetHitEventProductGroupOffersRequest,
  onCreateHitEventProductOfferRequest,
  onUpdateHitClubProductBaseRequest,
  onGetHitEventTicketsRequest,
  onGetEditTicketInformationRequest,
  onEditHitEventProductGroupRequest,
  onRemoveHitEventProductGroupRequest,
  onRemoveHitClubProductBaseRequest,
  onGetHitEventProductOfferRequest,
  onEditHitEventProductOfferRequest,
  onRemoveHitEventProductOfferRequest,
  onGetEditMembershipOfferRequest,
  onGetEditProductOfferInformationRequest,
  onCreateElectionPostRequest,
  onGetElectionPostsRequest,
  onGetElectionCandidaciesRequest,
  onCreateElectionCandidacyRequest,
  onUpdateElectionPostRequest,
  onMoveElectionPostRequest,
  onUpdateElectionCandidacyRequest,
  onMoveElectionCandidacyRequest,
  onRemoveElectionPostRequest,
  onRemoveElectionCandidacyRequest,
  onGetHitEventElectionResultRequest,
  onGetElectionPostResultRequest,
  onApproveMembersRequest,
  onUpdateHitClubOwnerRequest,
  onGetHitClubOwnerRequest,
  onMoveMembershipRequest,
  onCreateMembersReportRequest,
  onGetHitClubActiveStudentsDebouncedRequest,
  onGetActiveSubMembershipsRequest
} from './hitClub'

import {
  onCreateAccountRequest,
  onCheckAccountCreationRequest,
  onGetPaymentReportsListRequest,
  onGetPaymentEventsListRequest
} from './payments'

export default function* root() {

    yield takeLatest(REQUEST_LOGIN_CREDENTIALS.CREATE_REQUEST, onRequestLoginCredentials);

    yield takeLatest(AUTHENTICATION.CREATE_REQUEST, onLogin);

    yield takeLatest(CURRENT_USER.GET_REQUEST, onGetCurrentUser)
    yield takeLatest(CURRENT_USER.SET_LANGUAGE_REQUEST, onSetLanguageRequest)
    yield takeLatest(CURRENT_USER.SET_PROFILE_PICTURE_REQUEST, onSetProfilePictureRequest)

    yield takeLatest(METADATA.GET_REQUEST, onGetMetadata)
    yield takeLatest(METADATA.GET_HOBBIES_REQUEST, onGetHobbiesRequest)

    yield takeLatest(COMPANY_ONBOARDING.CREATE_COMPANY_USER_REQUEST, onCreateCompanyUser)
    yield takeLatest(COMPANY_ONBOARDING.CREATE_COMPANY_REQUEST, onCreateCompany)

    yield takeLatest(COMPANY.GET_ALL_REQUEST, onGetAllCompanyRequest);
    yield takeLatest(COMPANY.GET_DETAIL_REQUEST, onGetDetailCompanyRequest);  
    yield takeLatest(COMPANY.GET_FOLLOWERS_REQUEST, onGetCompanyFollowersRequest);
    yield takeLatest(COMPANY.GET_FEED_REQUEST, onGetFeedRequest);  
    yield takeLatest(COMPANY.CREATE_FEED_POST_REQUEST, onCreateCompanyPostRequest);
    yield takeLatest(COMPANY.UPDATE_COMPANY_REQUEST, onUpdateCompanyRequest);  
    yield takeLatest(COMPANY.UPDATE_COMPANY_USER_REQUEST, onUpdateCompanyUserRequest);  
    yield takeLatest(COMPANY.CONNECT_INSTAGRAM_REQUEST, onConnectCompanyInstagramRequest);
    yield takeLatest(COMPANY.DELETE_INSTAGRAM_REQUEST, onDeleteCompanyInstagramRequest);

    yield takeLatest(COMPANY.CREATE_USER_REQUEST, onCreateUserRequest);
    yield takeLatest(COMPANY.UPDATE_COMPANY_COVER_IMAGE_REQUEST, onUpdateCompanyCoverImageRequest)

    yield takeLatest(COMPANY.DELETE_HITPOST_REQUEST, onDeleteHitPostRequest);
    yield takeLatest(COMPANY.GET_HITEVENTS_REQUEST, onGetCompanyHitEventsRequest);
    yield debounce(200, COMPANY.GET_HITEVENTS_DEBOUNCED_REQUEST, onGetCompanyHitEventsRequest);

    yield takeLatest(COMMENTS.GET_REQUEST, onGetCommentsRequest);
    yield takeLatest(COMMENTS.CREATE_REQUEST, onCreateCommentRequest);
    yield takeLatest(COMMENTS.DELETE_REQUEST, onDeleteCommentRequest);

    yield takeLatest(LIKES.CREATE_REQUEST, onCreateLikeRequest);
    yield takeLatest(LIKES.DELETE_REQUEST, onDeleteLikeRequest);

    yield takeLatest(HITFACTOR_COLLECTIONS.CREATE_REQUEST, onCreateCollectionRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.CREATE_IMAGE_REQUEST, onCreateCollectionImageRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.DELETE_COLLECTION_REQUEST, onDeleteCollectionRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.DELETE_IMAGE_REQUEST, onDeleteImageRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.UPDATE_REQUEST, onUpdateCollectionRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.UPDATE_IMAGE_REQUEST, onUpdateCollectionImageRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.MOVE_IMAGE_REQUEST, onMoveImageImageRequest);
    yield takeLatest(HITFACTOR_COLLECTIONS.MOVE_COLLECTION_REQUEST, onMoveCollectionRequest);

    yield takeLatest(STUDENT.GET_REQUEST, onGetStudentRequest);

    yield takeLatest(HITSEARCH.GET_REQUEST, onGetSearchResultRequest);  
    yield takeLatest(HITSEARCH.GET_NEXT_REQUEST, onGetSearchResultRequest);  

    yield takeLatest(HITMANAGER.GET_STUDENTINFO_REQUEST, onGetStudentInfoRequest);
    yield takeLatest(HITMANAGER.GET_REQPROFILE_REQUEST, onGetReqProfileRequest);  
    yield takeLatest(HITMANAGER.GET_REQPROFILES_REQUEST, onGetReqProfilesRequest);
    yield takeLatest(HITMANAGER.GET_HITACTIONS_REQUEST, onGetHitActionsRequest);  
    yield takeLatest(HITMANAGER.UPDATE_REQPROFILE_REQUEST, onUpdateReqProfileRequest);
    yield takeLatest(HITMANAGER.UPDATE_HITACTION_REQUEST, onUpdateHitActionRequest);
    yield takeLatest(HITMANAGER.GET_STUDENT_INFO_LOG_REQUEST, onGetStudentInfoLogRequest);
    yield takeLatest(HITMANAGER.CREATE_REQPROFILE_REQUEST, onCreateReqProfileRequest);
    yield takeLatest(HITMANAGER.GET_STUDENTS_IN_REQPROFILE_REQUEST, onGetStudentsInReqProfileRequest);
    yield takeLatest(HITMANAGER.GET_STUDENTS_IN_REQPROFILES_REQUEST, onGetStudentsInReqProfilesRequest);
    yield takeLatest(HITMANAGER.GET_NONUPDATED_STUDENTS_IN_REQPROFILES_REQUEST, onGetNonUpdatedStudentsInReqProfilesRequest);
    yield debounce(400, HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILES_REQUEST, onSearchStudentsInReqProfilesRequest);
    yield debounce(400, HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILE_REQUEST, onSearchStudentsInReqProfileRequest);
    yield takeLatest(HITMANAGER.ADD_STUDENT_REQPROFILE_REQUEST, onAddStudentsToReqProfileRequest); 
    yield takeLatest(HITMANAGER.ADD_HITACTION_REQUEST, onAddHitActionRequest);
    yield takeLatest(HITMANAGER.UPDATE_STUDENT_REQPROFILE_REQUEST, onUpdateStudentInReqProfileRequest);
    yield takeLatest(HITMANAGER.DELETE_STUDENTS_REQPROFILE_REQUEST, onDeleteStudentsFromReqProfileRequest);
    yield takeLatest(HITMANAGER.DELETE_REQPROFILE_REQUEST, onDeleteReqProfileRequest);
    yield takeLatest(HITMANAGER.DELETE_HITACTION_REQUEST, onDeleteHitActionRequest);
    
    yield debounce(400, CHAT.SEARCH_CHAT_GROUP_REQUEST, onSearchChatGroupRequest);
    yield takeLatest(CHAT.GET_CURRENT_CHAT_GROUPS_REQUEST, onGetCurrentChatGroupsRequest);
    yield takeLatest(CHAT.GET_CHAT_MESSAGES_REQUEST, onGetChatMessagesRequest);
    yield takeLatest(CHAT.CREATE_CHAT_GROUP_REQUEST, onCreateChatGroupRequest);
    yield takeLatest(CHAT.CREATE_MULTIPLE_CHAT_GROUP_BY_REQID_REQUEST, onCreateMultipleChatGroupByReqIdRequest);
    yield takeLatest(CHAT.CREATE_MULTIPLE_CHAT_GROUP_BY_HITCLUBID_REQUEST, onCreateMultipleChatGroupByHitClubIdRequest);
    yield takeLatest(CHAT.CREATE_MULTIPLE_CHAT_GROUP_BY_STUDENTID_REQUEST, onCreateMultipleChatGroupByStudentIdRequest);
    yield takeLatest(CHAT.CREATE_CHAT_MESSAGE_REQUEST, onCreateChatMessageRequest);
    yield takeLatest(CHAT.ADD_CHAT_GROUP_PARTICIPANTS_REQUEST, onAddChatGroupParticipantsRequest);
    yield takeLatest(CHAT.DELETE_CHAT_GROUP_PARTICIPANTS_REQUEST, onDeleteChatGroupParticipantsRequest);
    yield takeLatest(CHAT.POLL_REQUEST, onPollRequest);
    yield takeLatest(CHAT.USER_TYPING_REQUEST, onUserTypingRequest);
    yield takeLeading(CHAT.DISPATCH_USER_TYPING_REQUEST, onDispatchUserIsTypingRequest);
    yield takeLatest(CHAT.CREATE_CHAT_MESSAGE_WITH_IMAGE_REQUEST, onCreateChatMessageWithImageRequest);
    // yield takeLatest(CHAT.DELETE_CHAT_GROUP_REQUEST, onDeleteChatGroupRequest);

    yield debounce(400, SEARCHGENERAL.STUDENT_SEARCH_REQUEST, onStudentSearchRequest);
    yield debounce(400, SEARCHGENERAL.USER_SEARCH_REQUEST, onUserSearchRequest);
    yield debounce(400, SEARCHGENERAL.HITCLUB_SEARCH_REQUEST, onHitClubSearchRequest);
    yield debounce(400, SEARCHGENERAL.COMPANY_SEARCH_REQUEST, onCompanySearchRequest);
    yield debounce(400, SEARCHGENERAL.PRODUCT_BASE_SEARCH_REQUEST, onProductBaseSearchRequest);
    yield debounce(400, SEARCHGENERAL.PRODUCT_OFFER_SEARCH_REQUEST, onProductOfferSearchRequest);
    yield debounce(400, SEARCHGENERAL.HITMEMBER_TO_CHAT_WITH_SEARCH_REQUEST, onSearchHitMemberToChatWithRequest);

    yield takeLatest(NOTIFICATIONS.ADD_DEVICE_REQUEST, onRegisterDeviceRequest);
    yield takeLatest(NOTIFICATIONS.GET_NOTIFICATIONS_REQUEST, onGetNotificationsRequest);
    yield takeLatest(NOTIFICATIONS.SET_NOTIFICATION_CLICKED_REQUEST, onSetNotificationClickedRequest);
    yield takeLatest(NOTIFICATIONS.POLL_REQUEST, onNotificationPollRequest);
    yield takeLatest(NOTIFICATIONS.SEND_PUSH_NOTIFICATION_REQUEST, onSendPushNotificationRequest)
    yield takeLatest(NOTIFICATIONS.SEND_PUSH_NOTIFICATION_HITCLUB_REQUEST, onSendPushNotificationToHitClubRequest)
    yield takeLatest(NOTIFICATIONS.SEND_PUSH_NOTIFICATION_HITCLUB_EXPIRED_REQUEST, onSendPushNotificationToHitClubExpiredRequest)

    yield takeLatest(APP_TOUR.SAVE_STATUS_REQUEST, onSaveStatusRequest);

    yield takeLatest(BUDDIES.GET_APPROVED_BUDDIES_REQUEST, onGetApprovedBuddiesRequest)

    yield takeLatest(TRAITS.GET_CHARACTERISTIC_GIVERS_REQUEST, onGetCharacteristicGiversRequest)

    yield takeLatest(HITCLUB.GET_HITCLUBS_MENU_REQUEST, onGetHitClubsMenuRequest)
    yield takeLatest(HITCLUB.GET_HITCLUB_REQUEST, onGetHitClubRequest)
    yield takeLatest(HITCLUB.GET_HITCLUBS_REQUEST, onGetHitClubsRequest)
    yield takeLatest(HITCLUB.GET_HITCLUB_MEMBERS_REQUEST, onGetHitClubMembersRequest)
    yield debounce(200, HITCLUB.GET_HITCLUB_MEMBERS_DEBOUNCED_REQUEST, onGetHitClubMembersRequest);
    yield takeLatest(HITCLUB.GET_HITCLUB_MEMBERS_REQUESTS_REQUEST, onGetHitClubMembersRequestsRequest)
    yield takeLatest(HITCLUB.GET_HITCLUB_HITEVENT_REQUEST, onGetHitClubHitEventRequest)
    yield takeLatest(HITCLUB.GET_HITCLUB_HITEVENTS_REQUEST, onGetHitClubHitEventsRequest)
    yield debounce(200, HITCLUB.GET_HITCLUB_HITEVENTS_DEBOUNCED_REQUEST, onGetHitClubHitEventsRequest)
    yield takeLatest(HITCLUB.CREATE_HITCLUB_REQUEST, onCreateHitClubRequest)
    yield takeLatest(HITCLUB.EDIT_HITCLUB_REQUEST, onEditHitClubRequest)
    yield takeLatest(HITCLUB.APPROVE_MEMBER_REQUEST, onApproveMemberRequest)
    yield takeLatest(HITCLUB.APPROVE_MEMBERS_REQUEST, onApproveMembersRequest)
    yield takeLatest(HITCLUB.CREATE_HITEVENT_REQUEST, onCreateHitEventRequest)
    yield takeLatest(HITCLUB.EDIT_HITEVENT_REQUEST, onEditHitEventRequest)
    yield takeLatest(HITCLUB.GET_CLUB_OWNER_REQUEST, onGetHitClubOwnerRequest)
    yield takeLatest(HITCLUB.CREATE_CLUB_OWNER_REQUEST, onCreateHitClubOwnerRequest)
    yield takeLatest(HITCLUB.UPDATE_CLUB_OWNER_REQUEST, onUpdateHitClubOwnerRequest)
    yield takeLatest(HITCLUB.CREATE_CLUB_OWNER_OTHER_REQUEST, onCreateHitClubOwnerOtherRequest)
    yield takeLatest(HITCLUB.REMOVE_CLUB_OWNER_REQUEST, onRemoveHitClubOwnerRequest)
    yield takeLeading(HITCLUB.IMPORT_MEMBERS_REQUEST, onImportMembersRequest)
    yield takeLatest(HITCLUB.SEND_REMINDER_MEMBERS_REQUEST, onSendRemindersToMembersRequest)
    yield takeLatest(HITCLUB.SEND_REMINDER_ALL_REQUEST, onSendRemindersToAllRequest)
    yield takeLatest(HITCLUB.EDIT_HITMEMBER_REQUEST, onEditHitMemberRequest)
    yield takeLatest(HITCLUB.REMOVE_HITMEMBER_REQUEST, onRemoveHitMemberRequest)
    yield takeLatest(HITCLUB.CREATE_TICKET_REQUEST, onCreateTicketRequest)
    yield takeLatest(HITCLUB.EDIT_TICKET_REQUEST, onEditTicketRequest)
    yield takeLatest(HITCLUB.GET_TICKET_QUESTIONS_REQUEST, onGetTicketQuestionsRequest)
    yield takeLatest(HITCLUB.CREATE_TICKET_QUESTIONS_REQUEST, onCreateTicketQuestionsRequest)
    yield takeLatest(HITCLUB.DELETE_TICKET_QUESTIONS_REQUEST, onDeleteTicketQuestionsRequest)
    yield takeLatest(HITCLUB.EDIT_TICKET_QUESTIONS_REQUEST, onEditTicketQuestionsRequest)
    yield takeLatest(HITCLUB.REMOVE_TICKET_REQUEST, onRemoveTicketRequest)
    yield takeLatest(HITCLUB.CREATE_MEMBERSHIP_OFFER_REQUEST, onCreateMembershipOfferRequest)
    yield takeLatest(HITCLUB.EDIT_MEMBERSHIP_OFFER_REQUEST, onEditMembershipOfferRequest)
    yield takeLatest(HITCLUB.GET_EDIT_MEMBERSHIP_OFFER_REQUEST, onGetEditMembershipOfferRequest)
    yield takeLatest(HITCLUB.DELETE_MEMBERSHIP_OFFER_REQUEST, onDeleteMembershipOfferRequest)
    yield takeLatest(HITCLUB.REMOVE_HITEVENT_REQUEST, onRemoveHitEventRequest)
    yield takeLatest(HITCLUB.CONNECT_INSTAGRAM_REQUEST, onConnectInstagramRequest)
    yield takeLatest(HITCLUB.MEMBER_LOG_REQUEST, onGetHitClubMemberLogRequest)
    yield takeLatest(HITCLUB.UPLOAD_ADMISSION_FILE_REQUEST, onUploadAdmissionFileRequest)
    yield takeLatest(HITCLUB.UPLOAD_REGISTRATION_FILE_REQUEST, onUploadRegistrationFileRequest)
    yield takeLatest(HITCLUB.ADD_MEMBER_REQUEST, onAddMemberRequest)
    yield takeLatest(HITCLUB.GET_FEED_REQUEST, onGetHitClubFeedRequest)
    yield takeLatest(HITCLUB.GET_HITEVENT_FEED_REQUEST, onGetHitEventFeedRequest)
    yield takeLatest(HITCLUB.DELETE_STUDENT_POST_REQUEST, onDeleteStudentPostRequest)
    yield takeLatest(HITCLUB.CREATE_STUDENT_POST_REQUEST, onCreateStudentPostRequest)
    yield takeLatest(HITCLUB.EDIT_STUDENT_POST_REQUEST, onEditStudentPostRequest)
    yield takeLatest(HITCLUB.DELETE_INSTAGRAM_REQUEST, onDeleteHitClubInstagramRequest)
    yield takeLatest(HITCLUB.UPDATE_MEMBER_STATUS_REQUEST, onUpdateMemberStatusRequest)
    yield takeLatest(HITCLUB.EDIT_HITEVENT_PARAMETERS_REQUEST, onGetParametersEditHitEventRequest)
    yield takeLatest(HITCLUB.CREATE_TICKET_PARAMETERS_REQUEST, onGetParametersCreateTicketRequest)
    yield takeLatest(HITCLUB.EDIT_TICKET_PARAMETERS_REQUEST, onGetParametersEditTicketRequest)
    yield takeLatest(HITCLUB.DELETE_INSTAGRAM_POST_REQUEST, onDeleteInstagramPostRequest)
    yield takeLatest(HITCLUB.CREATE_SALES_REPORT_REQUEST, onCreateSalesReportRequest)
    yield takeLatest(HITCLUB.CREATE_PAYOUT_REPORT_REQUEST, onCreatePayoutReportRequest)
    yield takeLatest(HITCLUB.GET_PRODUCT_BASE_REQUEST, onGetHitClubProductBaseRequest)
    yield takeLatest(HITCLUB.GET_PRODUCT_BASES_REQUEST, onGetHitClubProductBasesRequest)
    yield debounce(200, HITCLUB.GET_PRODUCT_BASES_DEBOUNCED_REQUEST, onGetHitClubProductBasesRequest)
    yield takeLatest(HITCLUB.CREATE_PRODUCT_BASE_REQUEST, onCreateHitClubProductBaseRequest)
    yield takeLatest(HITCLUB.UPDATE_PRODUCT_BASE_REQUEST, onUpdateHitClubProductBaseRequest)
    yield takeLatest(HITCLUB.REMOVE_PRODUCT_BASE_REQUEST, onRemoveHitClubProductBaseRequest)
    yield takeLatest(HITCLUB.GET_PRODUCT_GROUPS_REQUEST, onGetProductGroupsRequest)
    yield takeLatest(HITCLUB.CREATE_HITEVENT_PRODUCT_GROUP_REQUEST, onCreateHitEventProductGroupRequest)
    yield takeLatest(HITCLUB.EDIT_HITEVENT_PRODUCT_GROUP_REQUEST, onEditHitEventProductGroupRequest)
    yield takeLatest(HITCLUB.REMOVE_HITEVENT_PRODUCT_GROUP_REQUEST, onRemoveHitEventProductGroupRequest)
    yield takeLatest(HITCLUB.GET_HITEVENT_PRODUCT_GROUP_OFFERS_REQUEST, onGetHitEventProductGroupOffersRequest)
    yield takeLatest(HITCLUB.CREATE_HITEVENT_PRODUCT_OFFER_REQUEST, onCreateHitEventProductOfferRequest)
    yield takeLatest(HITCLUB.EDIT_HITEVENT_PRODUCT_OFFER_REQUEST, onEditHitEventProductOfferRequest)
    yield takeLatest(HITCLUB.REMOVE_HITEVENT_PRODUCT_OFFER_REQUEST, onRemoveHitEventProductOfferRequest)
    yield takeLatest(HITCLUB.GET_HITEVENT_TICKETS_REQUEST, onGetHitEventTicketsRequest)
    yield takeLatest(HITCLUB.GET_EDIT_TICKET_INFO_REQUEST, onGetEditTicketInformationRequest)
    yield takeLatest(HITCLUB.GET_HITEVENT_PRODUCT_OFFER_REQUEST, onGetHitEventProductOfferRequest)
    yield takeLatest(HITCLUB.GET_EDIT_PRODUCT_GROUP_INFO_REQUEST, onGetEditProductOfferInformationRequest)
    yield takeLatest(HITCLUB.CREATE_ELECTION_POST_REQUEST, onCreateElectionPostRequest)
    yield takeLatest(HITCLUB.GET_ELECTION_POSTS_REQUEST, onGetElectionPostsRequest)
    yield takeLatest(HITCLUB.GET_CANDIDACIES_REQUEST, onGetElectionCandidaciesRequest)
    yield takeLatest(HITCLUB.CREATE_CANDIDACY_REQUEST, onCreateElectionCandidacyRequest)
    yield takeLatest(HITCLUB.UPDATE_ELECTION_POST_REQUEST, onUpdateElectionPostRequest)
    yield takeLatest(HITCLUB.REMOVE_ELECTION_POST_REQUEST, onRemoveElectionPostRequest)    
    yield takeLatest(HITCLUB.MOVE_ELECTION_POST_REQUEST, onMoveElectionPostRequest)
    yield takeLatest(HITCLUB.UPDATE_CANDIDACY_REQUEST, onUpdateElectionCandidacyRequest)
    yield takeLatest(HITCLUB.REMOVE_CANDIDACY_REQUEST, onRemoveElectionCandidacyRequest)
    yield takeLatest(HITCLUB.MOVE_CANDIDACY_REQUEST, onMoveElectionCandidacyRequest)
    yield takeLatest(HITCLUB.HITEVENT_ELECTION_RESULT_REQUEST, onGetHitEventElectionResultRequest)
    yield takeLatest(HITCLUB.ELECTION_POST_RESULT_REQUEST, onGetElectionPostResultRequest)
    yield takeLatest(HITCLUB.MOVE_MEMBERSHIP_REQUEST, onMoveMembershipRequest)
    yield takeLatest(HITCLUB.CREATE_MEMBERS_REPORT_REQUEST, onCreateMembersReportRequest)
    yield debounce(500, HITCLUB.GET_HITCLUB_ACTIVE_STUDENTS_DEBOUNCED_REQUEST, onGetHitClubActiveStudentsDebouncedRequest)
    yield takeLatest(HITCLUB.GET_HITCLUB_ACTIVE_SUBMEMBERSHIPS_REQUEST, onGetActiveSubMembershipsRequest)

    yield takeLatest(PAYMENTS.CREATE_ACCOUNT_REQUEST, onCreateAccountRequest)
    yield takeLatest(PAYMENTS.CHECK_ACCOUNT_CREATION_REQUEST, onCheckAccountCreationRequest)
    yield takeLatest(PAYMENTS.GET_PAYMENT_REPORTS_REQUEST, onGetPaymentReportsListRequest)
    yield debounce(200, PAYMENTS.GET_PAYMENT_REPORTS_DEBOUNCED_REQUEST, onGetPaymentReportsListRequest)
    yield takeLatest(PAYMENTS.GET_PAYMENT_EVENTS_REQUEST, onGetPaymentEventsListRequest)
    yield debounce(200, PAYMENTS.GET_PAYMENT_EVENTS_DEBOUNCED_REQUEST, onGetPaymentEventsListRequest)
}
